import { useContext } from 'react';
import {
  TextField,
  Autocomplete,
  Checkbox,
  Grid
} from '@mui/material';
import { filter } from "lodash";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useQuery } from '@apollo/client/react';
import { KickOffContext } from '@/Contexts/KickOff';
import { GetCompanyContractTypesDocument } from '@/graphql/generated/graphql';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ContractTypes: React.FC = () => {
  const { contractTypeIds, setContractTypeIds } = useContext(KickOffContext);
  const { data } = useQuery(GetCompanyContractTypesDocument);

  return (
    <Grid mt={1} size={12}>
      <Autocomplete
        multiple
        disableCloseOnSelect
        fullWidth
        id="contract-types-selector"
        options={data?.getCompanyContractTypes || []}
        value={filter((data?.getCompanyContractTypes || []),
          contract => contractTypeIds && contractTypeIds.includes(contract.contractTypeId as string)
        ) || []}
        onChange={(_, newValue) => {
          setContractTypeIds(newValue.map(contract => contract.contractTypeId as string))
        }}
        getOptionLabel={(option) => option.name}
        renderOption={(props, option, { selected }) => (
          <li {...props} key={`selectedContracts-${option.id}`} >
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option.name}
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Contract Types"
            placeholder="Select contract types"
          />
        )}
        isOptionEqualToValue={(option, value) =>
          option.contractTypeId === value.contractTypeId
        }
      />
    </Grid>
  );
}

export default ContractTypes;
